/*
This function fixes dirty cache issue on IE/Edge browser while adding <meta> tags in the header does not help
until we find a better solution.
<meta http-equiv='cache-control' content='no-cache, no-store, must-revalidate'>
<meta http-equiv='pragma' content='no-cache'>
<meta http-equiv='expires' content='-1'> (-1 or 0 still doesn't work)

Steps to reproduce:
1. At Personal Information page, enter some value to First Name text-box.
2. Refresh the browser, notice that the previous entered value is still there.
3. Focus to another text-box such as Last Name text-box and enter some value.
4. Notice that the dirty First Name value disappears.

Technical explanation: When refreshing, the underlying HTML "value" attribute is empty, but the DOM "value" property is cached unexpectedly.
*/
export const forceIeEdgeReRender = (inputs) => {
    const userAgent = navigator.userAgent;
    if ((/MSIE/i.test(userAgent) || /Trident\//i.test(userAgent) || /Edge\/\d./i.test(userAgent)) && inputs.length > 0) {
        // Timeout millisecond 0 still works. Set it to 100 just to be safe.
        setTimeout(() => {
            inputs.forEach(input => {
                const element = document.getElementById(input.id);
                element.value = input.value;
                element.blur();
            });

            // Set focus on the first element.
            document.getElementById(inputs[0].id).focus();
        }, 500);
    }
};


// WEBPACK FOOTER //
// ./src/utils/cacheUtil.js